import { render } from "./checkedTag.vue?vue&type=template&id=5d708c2f&scoped=true"
import script from "./checkedTag.vue?vue&type=script&lang=js"
export * from "./checkedTag.vue?vue&type=script&lang=js"

import "./checkedTag.vue?vue&type=style&index=0&id=5d708c2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d708c2f"]])

export default __exports__